module.exports = __webpack_public_path__ + "static/media/hello-beautiful-mobile@2X.457aa925.png";